import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Heading } from 'components/Heading/Heading';
import { Section } from 'components/Section/Section';
import { isNumber } from 'helpers/verify';
import { LocalizableMessage } from 'components/LocalizableMessage/LocalizableMessage';
import { RESULT_TYPES, VERTICALS } from '../Search.constants';
import { messages } from '../Search.messages';
import css from '../Search.scss';

const { SCHEDULE, VENUE } = RESULT_TYPES;

export class ResultTypeSelector extends Component {
  renderVenueLabel() {
    const { vertical } = this.props;

    let message = messages.resultTypeStudios;
    if (vertical === VERTICALS.wellness) {
      message = messages.resultTypeBusinesses;
    } else if (vertical === VERTICALS.gym) {
      message = messages.resultTypeGyms;
    }

    return (
      <Heading className="zeta">
        <LocalizableMessage message={message} />
      </Heading>
    );
  }

  renderScheduleLabel() {
    const { vertical } = this.props;

    let message = messages.resultTypeSessions;
    if (vertical === VERTICALS.fitness) {
      message = messages.resultTypeClasses;
    }

    return (
      <Heading className="zeta">
        <LocalizableMessage message={message} />
      </Heading>
    );
  }

  renderVenueCount() {
    const { totalResults, venueResultsHeaderText } = this.props;

    return `${totalResults} ${venueResultsHeaderText}`;
  }

  renderScheduleCount() {
    const { locationName, totalResults, vertical, abbreviateCount } = this.props;

    if (vertical === VERTICALS.fitness) {
      return abbreviateCount ? (
        <FormattedMessage
          id="search.result-type.search-results-count.class.withoutLocation"
          defaultMessage="{totalResults, plural, =0 {No classes} one {{totalResults, number} class} other {{totalResults, number} classes}}"
          values={{
            totalResults,
          }}
        />
      ) : (
        <FormattedMessage
          id="search.result-type.search-results-count.class"
          defaultMessage="{totalResults, plural, =0 {No classes} one {{totalResults, number} class} other {{totalResults, number} classes}} near {locationName}"
          values={{
            totalResults,
            locationName,
          }}
        />
      );
    }

    return abbreviateCount ? (
      <FormattedMessage
        id="search.result-type.search-results-count.session.withoutLocation"
        defaultMessage="{totalResults, plural, =0 {No sessions} one {{totalResults, number} session} other {{totalResults, number} sessions}}"
        values={{
          totalResults,
        }}
      />
    ) : (
      <FormattedMessage
        id="search.result-type.search-results-count.session"
        defaultMessage="{totalResults, plural, =0 {No sessions} one {{totalResults, number} session} other {{totalResults, number} sessions}} near {locationName}"
        values={{
          totalResults,
          locationName,
        }}
      />
    );
  }

  render() {
    const {
      extraClass,
      hideCount,
      hideOptions,
      loading,
      locationName,
      onResultTypeClicked,
      selectedResultType,
      totalResults,
    } = this.props;
    const shouldShowCount = locationName && isNumber(totalResults) && !hideCount && !loading;

    return (
      <Section className={css.Search__tabs}>
        {!hideOptions && (
          <div className={css.Search__tabs__options}>
            <div
              data-qa="ResultTypeSelector.schedules"
              onClick={() => onResultTypeClicked(SCHEDULE)}
              className={cx(css.Search__tabs__options__type, {
                [css.Search__tabs__options__type__isSelected]: selectedResultType === SCHEDULE,
              })}>
              {this.renderScheduleLabel()}
            </div>

            <div
              data-qa="ResultTypeSelector.venues"
              onClick={() => onResultTypeClicked(VENUE)}
              className={cx(css.Search__tabs__options__type, {
                [css.Search__tabs__options__type__isSelected]: selectedResultType === VENUE,
              })}>
              {this.renderVenueLabel()}
            </div>
          </div>
        )}
        {shouldShowCount && (
          <span className={cx(css.Search__tabs__count, extraClass)}>
            {selectedResultType === VENUE ? this.renderVenueCount() : this.renderScheduleCount()}
          </span>
        )}
      </Section>
    );
  }
}

ResultTypeSelector.propTypes = {
  abbreviateCount: PropTypes.bool,
  extraClass: PropTypes.string,
  hideCount: PropTypes.bool,
  hideOptions: PropTypes.bool,
  loading: PropTypes.bool.isRequired,
  locationName: PropTypes.string,
  onResultTypeClicked: PropTypes.func.isRequired,
  selectedResultType: PropTypes.oneOf(Object.keys(RESULT_TYPES)),
  totalResults: PropTypes.number,
  venueResultsHeaderText: PropTypes.string.isRequired,
  vertical: PropTypes.oneOf(Object.keys(VERTICALS)),
};

ResultTypeSelector.defaultProps = {
  hideCount: false,
  hideOptions: false,
};
